import { AfterViewInit, Component, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Menu } from '../../class/appinterface';
import { TaskActionComponent } from '../../components/task-action/task-action.component';
import { BreadcrumbsComponent } from '../../layout/breadcrumbs/breadcrumbs.component';
import { NicaMenuService } from '../../services/nica-menu.service';
import { environment } from '../../../environments/environment';
import { Utenteservice } from '../../services/utente.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit, AfterViewInit {


  @ViewChild('tabs', { static: false }) tabs: BreadcrumbsComponent;

  menuType: string
  /***Imposta funzione Drowner****/
  selectedOpenMode = 'shrink';
  selectedPosition = 'left';
  selectedRevealMode = 'slide';

  isDrawerOpen = true;
  defaultVisible: boolean = true;



  toolbarContent = [{
    widget: 'dxButton',
    location: 'before',
    locateInMenu: "auto",
    options: {

      icon: 'menu',
      onClick: () => this.isDrawerOpen = !this.isDrawerOpen,
    },
  }];

  menuApp: Menu
  previousUrl: any;
  currentUrl: any;
  cronNav: Observable<any[]>;
  macroMenu;
  subMenu: any = null;
  currentMainMenuActive: any;
  isClose: boolean = false
  isJustClose: any;
  ShowRentri: boolean = false;
  isAgente: boolean = false
  constructor(private menuService: NicaMenuService, private router: Router, private activatedroute: ActivatedRoute, private userService: Utenteservice) {



  }
  ngAfterViewInit(): void {

    /*console.log($(window).height());
    console.log($(window).width());

    console.log(".header-container",$(".header-container").height())
    console.log(".footer",$(".footer").height())
    console.log(".page-wrapper",$(".page-wrapper").height())
    console.log(".page-content-tab",$(".page-content-tab").height()) 
    */
    //this.router.navigate(["main/dashboard"])

  }
  

  ngOnInit() {

    const infoUser = this.userService.InfoUtenteConnesso
    this.isAgente = (infoUser.tipoUtente === 10||infoUser.tipoUtente === 11)
    if (infoUser.tipoUtente === 10 ||infoUser.tipoUtente === 11) return this.router.navigate(['main/crm-per-il-momento']);

    this.ShowRentri = environment.SHOW_RENTRI;

    this.cronNav = this.menuService.cronNavData;

    let currentTabsItems = sessionStorage.getItem('currentTabsItems')

    if (!currentTabsItems) {

      this.router.navigate(["main/home"], {
        queryParams: {

          api: "",
          componentName: "HomepageComponent",
          currentTabId: "0",
          currentTabName: "Home",
          data: {},
          queryFilter: {},
          service: "",
          helpDoc: ""

        },
        skipLocationChange: true,
        replaceUrl: true
      })
    }
    this.menuType = 'type2';



    /******/

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {

      const root = this.router.routerState.snapshot.root;
      const cUrl = this.router.url.split('?')[0];

      if (cUrl == '/' || cUrl == '/main' || cUrl == '/login') {

        return
      }

      let params = root.queryParams;

      if (params)
        params = { ...params, ['path']: event.url }

      this.previousUrl = this.currentUrl;
      this.currentUrl = params;
      this.menuService.setPreviousUrl(this.previousUrl);

      this.menuService.setCronNav(params)
    });



  }



  vedi() {
    let varP = "SISTRI, CANTONE: “HA SOLO INGHIOTTITO DENARO” - TG 31/01/2019";
    var mess = "";
    alert(varP);
    alert(varP.charAt(45));
    alert(varP.charCodeAt(45));



  }

  setMenuType(nTipo) {
    this.menuType = 'type' + nTipo;
  }


  mainMenuClick(ev) {
    // console.log('currentMainMenuActive', ev);
    this.currentMainMenuActive = ev.mainMenuData
    this.subMenu = ev.items;
    this.menuService.hoCambiatoMenu.next(ev);
  }

  closeMainMenu(ev) {
    if (!this.isClose) {
      this.isClose = true
    }
    if (typeof ev != 'undefined') {
      if (ev.name == 'closeFromButton') {
        this.isClose = !this.isClose
      }
    }

  }
}
